(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccineDialogController', VaccineDialogController);

    VaccineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Vaccine'];

    function VaccineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Vaccine) {
        var vm = this;

        vm.vaccine = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vaccine.id !== null) {
                Vaccine.update(vm.vaccine, onSaveSuccess, onSaveError);
            } else {
                Vaccine.save(vm.vaccine, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:vaccineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
